import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Key, LogOut, ShieldCheck } from 'lucide-react';

const POSPinSetup = ({ 
  onSetPin, 
  saving,
  isPopup, 
  onLogout,
  userName
}) => {
  const [newPin, setNewPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [error, setError] = useState('');

  const handleSetPin = () => {
    setError('');
    
    if (!newPin || newPin.length < 4) {
      setError('PIN must be at least 4 digits');
      return;
    }
    if (newPin.length > 6) {
      setError('PIN must be 6 digits or less');
      return;
    }
    if (newPin !== confirmPin) {
      setError('PINs do not match');
      return;
    }
    
    onSetPin(newPin);
  };

  return (
    <div className="lock-screen" data-testid="pos-pin-setup">
      <div className="text-center max-w-sm mx-auto p-8">
        <div className="h-24 w-24 rounded-2xl bg-white/20 flex items-center justify-center mx-auto mb-6 backdrop-blur">
          <ShieldCheck className="h-12 w-12 text-white" />
        </div>
        <h1 className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Manrope' }}>Set Your POS PIN</h1>
        <p className="text-white/70 mb-2">Create a PIN to secure the POS</p>
        {userName && (
          <p className="text-white/50 text-sm mb-6">Logged in as: {userName}</p>
        )}
        
        <div className="space-y-4">
          <div>
            <Input
              type="text"
              placeholder="Enter 4-6 digit PIN"
              value={newPin}
              onChange={(e) => setNewPin(e.target.value.replace(/\D/g, '').slice(0, 6))}
              maxLength={6}
              className="pin-input w-full text-center text-2xl tracking-widest"
              data-testid="new-pin-input"
            />
          </div>
          
          <div>
            <Input
              type="text"
              placeholder="Confirm PIN"
              value={confirmPin}
              onChange={(e) => setConfirmPin(e.target.value.replace(/\D/g, '').slice(0, 6))}
              maxLength={6}
              className="pin-input w-full text-center text-2xl tracking-widest"
              onKeyDown={(e) => e.key === 'Enter' && handleSetPin()}
              data-testid="confirm-pin-input"
            />
          </div>

          {error && (
            <p className="text-red-300 text-sm">{error}</p>
          )}

          <Button
            onClick={handleSetPin}
            disabled={saving || !newPin || !confirmPin}
            className="w-full bg-white text-orange-600 hover:bg-white/90 font-semibold h-12"
            data-testid="set-pin-btn"
          >
            <Key className="h-4 w-4 mr-2" />
            {saving ? 'Setting PIN...' : 'Set PIN & Continue'}
          </Button>
        </div>

        {isPopup && onLogout && (
          <Button
            onClick={onLogout}
            variant="ghost"
            className="w-full mt-4 text-white/70 hover:text-white hover:bg-white/10"
          >
            <LogOut className="h-4 w-4 mr-2" /> Logout
          </Button>
        )}
      </div>
    </div>
  );
};

export default POSPinSetup;
